import React from 'react';
import { setClassNames } from 'ddc-classnames-js';
import { useSelector } from 'react-redux';
import { usePrefs } from 'wsm-common-data';

const Image = () => {
	const { url } = useSelector((state) => state.widgetData);
	const { imageWidth, imageHeight, enableImagePreload } = usePrefs();

	const isImagePreloaded = enableImagePreload === 'true';
	const imgSrc = isImagePreloaded
		? { src: url }
		: { src: '/images/blank.gif', 'data-src': url };

	if (!url) {
		return null;
	}

	return (
		<img
			className={setClassNames([
				'dynamic-resize',
				'img-responsive',
				!isImagePreloaded && 'lazy-image'
			])}
			height={imageHeight || null}
			width={imageWidth || null}
			alt=""
			{...imgSrc}
		/>
	);
};

export default Image;
